// Pure helpers shared by the Producción screens.

export const STAGE_LABELS = {
  antigua: 'Orden antigua',
  por_retirar: 'Por retirar',
  retirando: 'Retirando',
  lista_para_terminar: 'Lista para terminar',
  terminada: 'Terminada',
  finalizada: 'Finalizada',
  anulada: 'Anulada',
};

// "8,4" and "8.4" are both kg; anything else (or <= 0) is null.
export function parseKg(text) {
  if (text === null || text === undefined) return null;
  const clean = String(text).trim().replace(',', '.');
  if (!/^\d*\.?\d+$|^\d+\.$/.test(clean)) return null;
  const value = Number(clean);
  return value > 0 ? value : null;
}

// Like parseKg, but 0 is a valid answer (Robin's Devuelto / Usado / Merma).
export function parseKgOrZero(text) {
  if (text === null || text === undefined) return null;
  const clean = String(text).trim().replace(',', '.');
  if (!/^\d*\.?\d+$|^\d+\.$/.test(clean)) return null;
  return Number(clean);
}

export function formatKg(n) {
  return Number(n).toLocaleString('es-CL', { maximumFractionDigits: 3 });
}

// ISO "2027-01-15" (or a full datetime) -> "15/01/2027".
export function formatDate(iso) {
  if (!iso) return 'sin vencimiento';
  const [year, month, day] = String(iso).slice(0, 10).split('-');
  return `${day}/${month}/${year}`;
}

// ISO datetime -> "15/01/2027 14:03" in the browser's local time ('—' when empty).
export function formatDateTime(iso) {
  if (!iso) return '—';
  const d = new Date(iso);
  if (Number.isNaN(d.getTime())) return '—';
  const p = (n) => String(n).padStart(2, '0');
  return `${p(d.getDate())}/${p(d.getMonth() + 1)}/${d.getFullYear()} ${p(d.getHours())}:${p(d.getMinutes())}`;
}

// "a-3" -> {rack: 'A', shelf: '3'}; splits at the first dash only.
export function parseLocation(code) {
  const clean = String(code || '').trim().toUpperCase();
  const dash = clean.indexOf('-');
  if (dash <= 0 || dash === clean.length - 1) return null;
  return { rack: clean.slice(0, dash), shelf: clean.slice(dash + 1) };
}
